import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import Balance, { Type as BalanceType } from '@swf/components/Balance/Balance';
import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';
import { select } from '@swf/core/store';

import { TXTCLI_Total_Tournament_Money_Xin_N0X, TXTMOB_Balances } from './Balances.messages.json';
import styles from './Balances.scss';

const Balances: React.FC = () => {
  const { balances = [], totalTMoney = 0, totalTMoneyCurrency } = useSelector(select.account.get);

  if (!totalTMoneyCurrency) {
    return null;
  }

  const showIndividualBalances = balances.length > 1;

  return (
    <>
      <Translation {...TXTCLI_Total_Tournament_Money_Xin_N0X} values={{ '0': totalTMoneyCurrency }}>
        {(translation) => <h2 className={styles.titleTotal}>{translation}</h2>}
      </Translation>
      <Balance
        balance={
          <>
            T<CurrencyAmount value={totalTMoney} currency={totalTMoneyCurrency} />
          </>
        }
        type={BalanceType.TournamentMoney}
        className={styles.balance}
      />
      {showIndividualBalances && (
        <>
          <Translation {...TXTMOB_Balances}>
            {(translation) => <div className={styles.titleBalances}>{translation}</div>}
          </Translation>
          <table className={styles.balances}>
            <tbody>
              {balances.map((balance, index) => (
                <tr key={index} className={styles.balance}>
                  <td className={styles.currency}>{balance.currency}</td>
                  <td>T{<CurrencyAmount value={balance.tMoney} currency={balance.currency} />}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
    </>
  );
};

export default Balances;
